import { RootState } from '../types/rootstate'
import { appStore } from '../appStore'
import { addStyles } from '../actions/trigger/add-styles'
import { parentGetPromise } from './zoid-utils'

export function reloadStyles () {
  const state: RootState = appStore.getState()
  const customStyles = state.customStyles

  if (customStyles.widget) {
    addStyles(customStyles.widget)
  }

  if (customStyles.launcher) {
    parentGetPromise('rpc', 'launcher', 'addStyles', [ customStyles.launcher ])
      .catch((error) => {
        console.warn('Could not reload styles', error)
      })
  }
}
